export const typesActionsAuth = {
  authLogin: '[user] login',
  authLogout: '[user] logout',
  authUpdate: '[user] update',
};
